import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, ButtonToolbar, FormControl, Radio} from "react-bootstrap";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import AppConfig from "../../../../../../AppConfig";
import TopSelectSlownik from "../../../../../../componentsTopsa/selects/TopSelectSlownik";
import PojazdyService from "../../../../zasobyConfig/pojazdy/PojazdyService";
import KierowcyService from "../../../../zasobyConfig/kierowcy/KierowcyService";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import Validator from "../../../../../../utilities/Validator";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";


export default class ObsadaListaZamianaForm extends Component {
    constructor(props) {
        super(props);
        this.state = {

            kierowcy: [],
            pojazdy: [],


            idKu: '',
            data: '',
            godzina: '',
            trasa: '',

            idOb: null,

            stareIdpojazdu: 0,
            stareIdkierowcy: 0,
            starykierowca: '',
            staryPojazd: '',
            powod: null,
            nowykierowca: null,
            nowypojazd: null,
            typplatnosci: null,
            stawka: 0,
            uwagi: '',

            messages: []
        };
        this.onChangePowod = this.onChangePowod.bind(this)
        this.onChangeTypPlatnosci = this.onChangeTypPlatnosci.bind(this)
        this.onChangeNowyKierowca = this.onChangeNowyKierowca.bind(this)
        this.onChangeNowyPojazd = this.onChangeNowyPojazd.bind(this)
        this.onChangeStawka = this.onChangeStawka.bind(this)
        this.onChangeUwagi = this.onChangeUwagi.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.przygotujForme(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.przygotujForme(nextprops)
    }

    przygotujForme(props) {
        if (Boolean(props.obsadaDoZamiany)) {

            this.setState({
                idOb: props.obsadaDoZamiany.id_ob,
                stareIdpojazdu: props.obsadaDoZamiany.id_po,
                stareIdkierowcy: props.obsadaDoZamiany.id_ki,
                idKu: props.obsadaDoZamiany.id_ku,
                data: props.obsadaDoZamiany.data,
                godzina: props.obsadaDoZamiany.godz_1p,
                trasa: props.obsadaDoZamiany.trasa,


            })

            if (Boolean(props.obsadaDoZamiany.id_ku)) {
                this.pobierzDostepnePojazdy(props.obsadaDoZamiany.id_ku)
                this.pobierzDostepnychKierowcow(props.obsadaDoZamiany.id_ku)
            }

            this.setState({
                starykierowca: props.obsadaDoZamiany.imie_naz,
                staryPojazd: props.obsadaDoZamiany.naz_po
            })

        }
    }

    pobierzDostepnePojazdy(idKu) {
        PojazdyService.getPojazdyDostepne(idKu).then(function (response) {
            let array = Array.from(response.data, i => {
                return {
                    ...i,
                    informacje: i.marka + ' ' + i.model + ' ' + i.nrRej
                }
            })
            this.setState({
                pojazdy: array
            })
        }.bind(this))
    }

    pobierzDostepnychKierowcow(idKu) {
        KierowcyService.getZajeciKierowcy(idKu).then(function (response) {
            let arr = Array.from(response.data, item => {
                return {
                    ...item,
                    imieNazwisko: item.imie + ' ' + item.nazwisko
                }
            })
            this.setState({kierowcy: arr})
        }.bind(this))
    }

    onChangeNowyKierowca(e) {
        this.setState({nowykierowca: e})
    }


    onChangeNowyPojazd(e) {
        this.setState({nowypojazd: e})
    }

    onChangePowod(e) {
        this.setState({powod: e})
    }

    onChangeTypPlatnosci(e) {
        this.setState({typplatnosci: e})
    }

    onChangeUwagi(e) {
        if (e.target.value.length <= 100) {
            this.setState({uwagi: e.target.value})
        } else {
            document.getElementById('inputUwagi').value = this.state.uwagi
        }
    }

    onChangeStawka(e) {
        this.setState({
            stawka: e.target.value
        })
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.messages
        arr.push(msg)
        this.setState({messages: arr})
    }

    onClickZapisz() {

        this.setState({messages: []})
        this.state.messages = []
        let poprawne = true;
        let data = null

        if(!Boolean(this.state.stareIdpojazdu)){
            if (!Boolean(this.state.nowypojazd)) {
                poprawne = false
                this.dodajDoValidatorMessages('Nie wybrano pojazdu')
            }
        }
        if(!Boolean(this.state.stareIdkierowcy)){
            if (!Boolean(this.state.nowykierowca)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano nowego kierowcy')
            }
            if (!Boolean(this.state.powod)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano powodu zmiany')
            }
            if (!Boolean(this.state.typplatnosci)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie wybrano typu płatności')
            } else {
                if (this.state.typplatnosci.wartosc == 'EXTRA') {
                    if (!Boolean(this.state.stawka)) {
                        poprawne = false;
                        this.dodajDoValidatorMessages('Wybierając typ płatności EXTRA należy uzupełnić stawkę')
                    }
                    else {
                        if (!Validator.validateIntOrDouble(this.state.stawka)) {
                            poprawne = false;
                            this.dodajDoValidatorMessages('Wartość stawki jest niepoprawna')
                        }
                        if (parseFloat(this.state.stawka) < 0) {
                            poprawne = false;
                            this.dodajDoValidatorMessages('Wartość stawki jest ujemna')
                        }
                    }
                }
            }
        }

        if (poprawne) {
            data = {
                "idOb": this.state.idOb,
                "powodZam": Boolean(this.state.powod) ? this.state.powod.wartosc : '',
                "stawka": Boolean(this.state.typplatnosci) ? Boolean(this.state.typplatnosci.wartosc == 'EXTRA') ? parseFloat(this.state.stawka) : 0 : 0,
                "typPlat": Boolean(this.state.typplatnosci) ? this.state.typplatnosci.wartosc : 'PODSTAWA',
                "idKi": Boolean(this.state.nowykierowca) ? this.state.nowykierowca.idKi : this.state.stareIdkierowcy,
                "idPo": Boolean(this.state.nowypojazd) ? this.state.nowypojazd.idPo : this.state.stareIdpojazdu,
                "uwagi":this.state.uwagi,
                "status_obsady": 1,

                "starykierowca":this.state.starykierowca,
                "starypojazd:":this.state.staryPojazd,
                "stareIdKierowcy":this.state.stareIdkierowcy,
                "stareIdPojazdu":this.state.stareIdpojazdu,
            }

            this.props.handleEdytujZasobyObsady(data)
        }

    }

    renderPojazdSelect(option) {
        return (
            <div>
                <span>{option.informacje}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status) ?
                            <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                            :
                            <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> zajęty</span>

                    }
                </div>
            </div>
        )
    }

    renderKierowcaSelect(option) {
        return <div>
            <span>{option.imieNazwisko}</span>
            <div className={'pull-right'}>
                {
                    (option.status == 1) ?
                        <span style={{fontSize: '12px', color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
                        :
                        <span style={{fontSize: '12px', color: 'firebrick'}}><i className={'fa fa-times'}></i> zajęty</span>
                }
            </div>
        </div>
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div
                        className={'fieldset-label'}>Wprowadź zmianę w obsadzie
                    </div>
                    <Form horizontal={true}>
                        <div>
                            <FormGroup>
                                <Col xs={12}>
                                    <h4 style={{margin: '15px 0'}}>
                                        Kurs: <span className={'label label-ebus-primary'}
                                                    style={{fontSize: 'inherit'}}>{this.state.idKu}</span> {this.state.trasa}, {this.state.data} {Boolean(this.state.godzina) ? DateAndTimeFormat.formatHHMM(this.state.godzina) : ''}
                                    </h4>
                                </Col>
                            </FormGroup>
                        </div>
                        <Row>
                            <Col xs={12} sm={6}>
                                <div>
                                    <h5 className={'formHeading'}>Zamiana kierowcy</h5>
                                    <FormGroup>
                                        <Col xs={12} lg={5}>
                                            <ControlLabel>
                                                Zmieniany kierowca
                                            </ControlLabel>
                                            <FormControl disabled defaultValue={this.state.starykierowca}/>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <ControlLabel>
                                                Powód zamiany
                                            </ControlLabel>
                                            <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/OBSADA_POWOD_ZAMIANA'}
                                                              onChange={this.onChangePowod}
                                                              valueKey={'id'} labelKey={'wartosc'}
                                            />
                                        </Col>
                                        <TopIf isTrue={Boolean(this.state.powod) ? this.state.powod.wartosc == 'INNE' : false}>
                                            <Col xs={12} lg={11}>
                                                <ControlLabel>
                                                    Uwagi <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.uwagi.length}/100 znaków</span>
                                                </ControlLabel>
                                                <FormControl type={'text'} onChange={this.onChangeUwagi} id={'inputUwagi'}/>
                                            </Col>
                                        </TopIf>
                                    </FormGroup>
                                    <FormGroup>
                                        <Col xs={12} lg={5}>
                                            <ControlLabel>
                                                Nowy kierowca:
                                            </ControlLabel>
                                            <TopSelect onChange={this.onChangeNowyKierowca} value={this.state.nowykierowca}
                                                       options={this.state.kierowcy}
                                                       valueKey={'idKi'} labelKey={'imieNazwisko'}
                                                       optionRenderer={this.renderKierowcaSelect}
                                                       valueRenderer={this.renderKierowcaSelect}
                                            />
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <ControlLabel>
                                                Typ płatności
                                            </ControlLabel>
                                            <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/OBSADA_TYP_PLATNOSCI'}
                                                              onChange={this.onChangeTypPlatnosci}
                                                              valueKey={'id'} labelKey={'wartosc'}
                                            />
                                        </Col>
                                        <TopIf isTrue={Boolean(this.state.typplatnosci) ? this.state.typplatnosci.wartosc == 'EXTRA' : false}>
                                            <Col xs={12} lg={3}>
                                                <ControlLabel>
                                                    Stawka
                                                </ControlLabel>
                                                <FormControl type={'number'} onChange={this.onChangeStawka}/>
                                            </Col>
                                        </TopIf>

                                        {/*<Col xs={12} lg={12}>
                                            <div className={'add-label-margin'}></div>
                                            <ButtonToolbar>
                                                <TopButtonCancel onClick={() => {
                                                    this.props.handleClickAnuluj()
                                                }}/>
                                                <TopButtonSave onClick={this.onClickZapisz}/>
                                            </ButtonToolbar>
                                        </Col>*/}
                                    </FormGroup>
                                </div>

                            </Col>
                            <Col xs={12} sm={6}>
                                <div>
                                    <h5 className={'formHeading'}>Zamiana pojazdu</h5>
                                    <FormGroup>
                                        <Col xs={12} lg={6}>
                                            <ControlLabel>
                                                Zmieniany pojazd
                                            </ControlLabel>
                                            <FormControl disabled defaultValue={this.state.staryPojazd}/>
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <ControlLabel>
                                                Nowy pojazd:
                                            </ControlLabel>
                                            <TopSelect onChange={this.onChangeNowyPojazd} value={this.state.nowypojazd}
                                                       options={this.state.pojazdy} valueKey={'idPo'}
                                                       labelKey={'informacje'} valueRenderer={this.renderPojazdSelect}
                                                       optionRenderer={this.renderPojazdSelect}
                                            />
                                        </Col>
                                        {/*<Col xs={12} lg={12}>
                                            <div className={'add-label-margin'}></div>
                                            <ButtonToolbar>
                                                <TopButtonCancel onClick={() => {
                                                    this.props.handleClickAnuluj()
                                                }}/>
                                                <TopButtonSave onClick={this.onClickZapisz}/>
                                            </ButtonToolbar>
                                        </Col>*/}
                                    </FormGroup>
                                </div>
                            </Col>

                            <Col xs={12} lg={12}>
                                <div className={'pull-right'}>
                                <ButtonToolbar>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleClickAnuluj()
                                    }}/>
                                    <TopButtonSave onClick={this.onClickZapisz}/>
                                </ButtonToolbar>
                                </div>
                            </Col>
                        </Row>


                        <div>
                            <ValidatorMessages messages={this.state.messages}/>
                        </div>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaLista/components/ObsadaListaZamianaForm.js